import React from 'react'
import ModeFullScreen from './modeFullScreen'

const ModeSpeaker = () => <ModeFullScreen showTotalVotes />

export default ModeSpeaker
